import { Box, Typography } from '@mui/material';
import Card from '@mui/material/Card';
import { useState } from 'react';

interface CardBigNumbersProps {
  title: string;
  icone: React.ReactNode;
  data: any;
  margin?: number | string;
  position?: string;
  sizeTitle?: number | string;
}

function CardBigNumbers({
  title,
  icone,
  data,
  margin,
  position,
  sizeTitle,
}: CardBigNumbersProps) {
  const [activeDevices, setActiveDevices] = useState<string[]>([]);

  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: position || 'column',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 3,
        backgroundColor: 'var(--app-surface-2)',
        width: '100%',
        height: '100%',
        boxShadow: '0 4px 24px rgba(0,0,0,0.25)',
        padding: 3,
        '@media (max-width: 600px)': {
          flexDirection: 'column',
          padding: 2,
        },
      }}
    >
      <Box>
        <Typography fontSize={{ xs: 40, sm: 70, md: 70 }}>{data}</Typography>
      </Box>
      <Box
        display={'flex'}
        flexDirection={'row'}
        marginTop={2}
        alignItems={'center'}
        sx={{
          '@media (max-width: 600px)': {
            flexDirection: 'column',
            marginTop: 1,
          },
        }}
      >
        {icone}
        <Typography margin={{ xs: 0.5, sm: 1 }} fontSize={{ md: sizeTitle }}>
          {title}
        </Typography>
      </Box>
    </Card>
  );
}

export default CardBigNumbers;
